import React from 'react';

export const MinusIcon = () => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">\
      <path d="m7 12h10"/>
      <circle cx="12" cy="12" r="10"/>
    </g>
  </svg>
)
